import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GroupTable } from './GroupTable';
import {
    fetchGroups,
    selectAllGroups,
    getGroupStatus,
    getGroupPageInfo,
    resetGroupState,
} from 'features/groups/groupsSlice';
import { LoadingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';
import { activateLoading, deactivateLoading } from 'GeminiViewerComponent/features/globals/loadingProgressSlice';

function GroupManagementTab() {
    const dispatch = useDispatch();
    const ref = useRef(false);
    const groups = useSelector(selectAllGroups);
    const groupStatus = useSelector(getGroupStatus);
    const pageInfo = useSelector(getGroupPageInfo);
    const [sortBy, setSortBy] = useState('display_name');
    const [sortDirection, setSortDirection] = useState('ASC');
    const [groupPayload, setGroupPayload] = useState({
        sort: `${sortDirection === 'ASC' ? '' : '-'}${sortBy}`,
    });

    const getGroupData = async (payload) => {
        dispatch(activateLoading());
        await dispatch(fetchGroups({ ...payload }));
        dispatch(deactivateLoading());
    };

    useEffect(() => {
        if (ref.current === true) {
            getGroupData({ ...groupPayload });
        }
    }, [groupPayload]);

    useEffect(() => {
        return async () => {
            await dispatch(resetGroupState());
        };
    }, []);

    useEffect(() => {
        if (groupStatus === LoadingStatus.Idle) {
            getGroupData({ ...groupPayload });
        }
        ref.current = true;
    }, [groupStatus]);

    const setSorting = (_sortBy, _sortDirection) => {
        setSortBy(_sortBy);
        setSortDirection(_sortDirection);
        setGroupPayload({
            ...groupPayload,
            sort: `${_sortDirection === 'ASC' ? '' : '-'}${_sortBy}`,
        });
    };

    return (
        <GroupTable
            groups={groups}
            pageInfo={pageInfo}
            groupPayload={groupPayload}
            setGroupPayload={setGroupPayload}
            sortDirection={sortDirection}
            sortBy={sortBy}
            handleSort={(_sortBy, _sortDirection) => setSorting(_sortBy, _sortDirection)}
        />
    );
}

export { GroupManagementTab };
